import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';

const DIRECT = [
  '고객사가 자산 소유',
  '고객사가 내용연수에 따라 감가상각',
  '초기 현금 지출 부담 발생',
];

const BNPL = [
  '계약기간 중 오퍼그룹 소유',
  '고객사는 자산을 이용하며 분할납부',
  '완납 후 계약에 따라 소유권 이전',
];

/** 시안 "직접 구매와 오퍼그룹 BNPL" 비교 카드 */
const CashFlow = () => (
  <section className={`${p.section} ${p.reveal}`}>
    <div className={p.head}>
      <div className={p.badge}>CASH FLOW COMPARISON</div>
      <h2 className={`${p.title} ${p.titleLg}`}>
        직접 구매와 오퍼그룹 BNPL,
        <br />
        결제 방식에 따른 차이를 살펴보세요.
      </h2>
      <p className={p.lead}>공급가액 1억원의 사업용 자산을 12개월 동안 이용하는 단순 예시입니다.</p>
    </div>

    <div className={p.vsRow}>
      <div className={p.vsCard}>
        <div className={p.vsLabel}>직접 일시구매</div>
        <div>
          <div className={p.vsAmount}>1억 1,000만원</div>
          <div className={p.vsCaption}>구매 시점에 일시지출</div>
        </div>
        <div className={p.vsList}>
          {DIRECT.map((text) => (
            <div className={p.vsItem} key={text}>
              <span className={p.vsBullet} aria-hidden="true" />
              {text}
            </div>
          ))}
        </div>
      </div>

      <div className={p.vsDivider}>VS</div>

      <div className={`${p.vsCard} ${p.vsCardDark}`}>
        <div className={`${p.vsLabel} ${p.vsLabelDark}`}>오퍼그룹 BNPL · 소유권 이전형 예시</div>
        <div>
          <div className={`${p.vsAmount} ${p.vsAmountDark}`}>약 917만원</div>
          <div className={`${p.vsCaption} ${p.vsCaptionDark}`}>12개월 월납부 예시</div>
        </div>
        <div className={p.vsList}>
          {BNPL.map((text) => (
            <div className={`${p.vsItem} ${p.vsItemDark}`} key={text}>
              <span className={`${p.vsBullet} ${p.vsBulletDark}`} aria-hidden="true" />
              {text}
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className={p.note}>
      * 총납부금 1억 1,000만원(부가세 포함)을 12개월로 나눈 단순 예시입니다. 실제 계약 명칭,
      계약금액, 비용처리 및 세무효과는 거래내용과 계약조건에 따라 달라질 수 있습니다.
    </div>
  </section>
);

export default CashFlow;
